import React from 'react';
import { Outlet } from 'react-router-dom';
import Header from './Header'; // Import the Header component

function AdminLayout() {
  return (
    <div>
      <Header /> {/* Use the Header component here */}
      <Outlet /> {/* This will render the nested routes (e.g., OldResurveyList) */}
    </div>
  );
}

export default AdminLayout;